<script setup>
  import { storeToRefs } from "pinia";
  import { ListContainer } from "@/components/episto-ui/list";
  import { ListItem } from "@/components/episto-ui/list";
  import { Switch } from "@/components/ui/switch";
  import { useMCampaignActionsStore } from "@stores/mCampaignActions";
  import GenerateQuotaActionsButton from "./GenerateQuotaActionsButton.vue";

  const mCampaignActionsStore = useMCampaignActionsStore();
  const { mCampaignActions } = storeToRefs(mCampaignActionsStore);
  const {
    selectAction,
    duplicateAction,
    removeAction,
    addAction,
    toggleActive,
    isActionSelected,
    isActionActive,
    triggerLabel,
    actionLabel,
    actionErrorMessages,
  } = mCampaignActionsStore;

  const actionTitle = (item, index) => item.name?.trim() || `Action #${index + 1}`;
</script>

<template>
  <ListContainer
    element-name="action"
    :add-element="addAction"
    :show-header="false">
    <template #elements>
      <ListItem
        v-for="(item, index) in mCampaignActions"
        :key="item.token || `action-item-${index}`"
        :index="index"
        :element-title="actionTitle(item, index)"
        :select-element="selectAction"
        :is-element-selected="isActionSelected"
        :element-error-messages="actionErrorMessages"
        :duplicate-element="duplicateAction"
        :delete-element="removeAction"
        confirm-deletion>
        <template #prefix>
          <Switch
            :model-value="isActionActive(index)"
            @update:model-value="(value) => toggleActive(index, value)" />
        </template>
        <template #additional-content>
          <div class="flex flex-col gap-1 text-xs text-muted-foreground">
            <span class="truncate">Trigger: {{ triggerLabel(index) }}</span>
            <span class="truncate">Action: {{ actionLabel(index) }}</span>
          </div>
        </template>
      </ListItem>
    </template>
    <template #footer>
      <GenerateQuotaActionsButton />
    </template>
  </ListContainer>
</template>
